import { ApiGldGldsListRequest, GLD } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { getSearchKey } from "@/components/searchbox";
import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { useRouterTableData } from "@/hooks/use-router-table-data";
import { useGldListQuery } from "@/queries/query-gld";

import { FilterWrapper } from "../../components/filter-wrapper";

import { GldFilters } from "./components/gld-filters";
import { GldObservationTable } from "./components/gld-observation-table";
import { gldInformation } from "./types";

export const columnDefinitions: ColumnDefinition<GLD>[] = gldInformation.map(
  ({ key, label }, index) => ({
    title: label,
    renderFunction: (row) =>
      renderDefault(row[key], index === 0 ? `/gld/startregistratie/${row.uuid}/` : undefined),
    width: "1fr",
  })
);

export function GldTable() {
  const {
    page,
    setPage,
    searchField: _searchField,
    searchString,
    setSearchField,
    setSearchString,
  } = useRouterTableData({ keyAddon: "GLD" });
  const searchField =
    (_searchField as keyof ApiGldGldsListRequest | undefined) || getSearchKey(gldInformation[0]);
  const queryParams: ApiGldGldsListRequest = {
    page,
    // FUTURE do something with gmnIds and unlinkedChecked
    ...(searchField ? { [searchField]: searchString } : {}),
  };
  const { data: gldList, isLoading } = useGldListQuery(queryParams);
  const paginationProps = useQueryPagination({
    queryResponse: gldList,
    page,
    setPage,
  });

  return (
    <>
      <FilterWrapper>
        <GldFilters {...{ searchField, searchString, setSearchField, setSearchString }} />
      </FilterWrapper>
      <TableOverview
        isLoading={isLoading}
        rowAccordion={(gld: GLD) => {
          if (!gld.uuid) return null;

          if (!gld.nrOfObservations && !gld.researchLastDate) return null;

          return gld.nrOfObservations ? <GldObservationTable gld={gld.uuid} /> : null;
        }}
        tableData={gldList?.results || []}
        columnDefinitions={columnDefinitions}
        paginationProps={paginationProps}
      />
    </>
  );
}
